<template>
    <div>
        <v-card v-if="survey && !submitted" tile color="grey lighten-3">
            <v-container>
                <v-card-title><h3>{{survey.name}}</h3></v-card-title>
                <v-card-text>
                    <h3>{{survey.description}}</h3>
                </v-card-text>

                <v-stepper v-model="surveyStepper" v-if="survey">
                    <v-stepper-header>
                        <template v-for="(page, stepIndex) in survey.pages">
                            <v-stepper-step :key="'header' + stepIndex" :step="page.number" :complete="surveyStepper > stepIndex">
                                {{page.name}}
                            </v-stepper-step>
                            <v-divider v-if="stepIndex < survey.pages.length - 1" :key="'divider' + stepIndex" />

                        </template>
                    </v-stepper-header>

                    <v-stepper-items class="pa-0">
                        <v-stepper-content :step="page.number" v-for="page in survey.pages" :key="page.number">
                            <v-form ref="surveyVoteForm" v-model="valid" lazy-validation>
                                <v-card tile color="">
                                    <v-card-text>

                                        <div v-for="(question, qIndex) in page.questions" :key="qIndex" class="mt-4">
                                            <h3 class="pa-2 secondary--text"> {{ question.title ? question.title.replace(/<[^>]*>/g, '') : question.title }}</h3>

                                            <!--text-->
                                            <div v-if="question.questionTypeId == shortAnswer" class="options pa-2">
                                                <v-text-field hide-details outlined v-model="question.selectedValue" dense class="mt-3" :disabled="question.voted" :rules="question.required ? nameRules : []" prepend-icon="mdi-text-shadow" />
                                            </div>
                                            <!--number-->
                                            <div v-if="question.questionTypeId == number" class="options pa-2">
                                                <v-text-field type="number" hide-details outlined v-model="question.selectedValue" dense class="mt-3" :disabled="question.voted" :rules="question.required ? nameRules : []" prepend-icon="mdi-numeric" />
                                            </div>

                                            <!--rating-->
                                            <div v-if="question.questionTypeId == rating" class="options pa-2">
                                                <v-row>
                                                    <div style="float: right; width: 60%; margin-top: 10px ">
                                                        <StarRating v-model="question.selectedValue" v-if="question.questionTypeParams==='Star'" :length="rateLength" :aria-label="question.title" @input="starClicked($event, question)"></StarRating>
                                                        <SmileyRating v-model="question.selectedValue" v-if="question.questionTypeParams==='Emoji'" :aria-label="question.title"></SmileyRating>
                                                    </div>
                                                </v-row>
                                            </div>

                                            <!--NPS-->
                                            <div class="text-center" v-if="question.questionTypeId == nps">
                                                <NPS :increaseDecrease="false" v-model="question.selectedValue"></NPS>
                                            </div>

                                            <!--YesNo-->
                                            <div v-if="question.questionTypeId == yesNo" class="options pa-2">
                                                <LikeDislike v-model="question.selectedValue"></LikeDislike>
                                            </div>

                                            <!--date-->
                                            <div v-if="question.questionTypeId == date" class="options pa-2">
                                                <DatePicker dense outlined v-model="question.selectedValue" :rules="question.required ? nameRules : []" />
                                            </div>

                                            <!--textarea-->
                                            <div v-if="question.questionTypeId == textArea" class="options pa-2">
                                                <v-textarea outlined v-model="question.selectedValue" :value="question.selectedValue" prepend-icon="mdi-format-align-justify"></v-textarea>
                                            </div>

                                            <!--PredefineDropdown-->
                                            <div v-if="question.questionTypeId == PredefineDropdown" class="options pa-2">
                                                <v-autocomplete :rules="question.required ? nameRules : []" dense outlined
                                                                v-if="question.questionTypeId == PredefineDropdown"
                                                                v-model="PredefineDropdownSelectedValue[qIndex]"
                                                                :items="PredefineDropdownItems" item-value="id" item-text="name"
                                                                :label="$t('Select')"
                                                                @change="handlePredefineDropdownChange(qIndex,PredefineDropdownSelectedValue[qIndex])" />
                                                <div ref="autocompleteContainer"></div>

                                                <div id="autocomplete-container">
                                                    <v-row v-for="(items, optDropIndex) in predefineDropDownDependent[qIndex]" :key="optDropIndex">
                                                        <div class="options pa-2">
                                                            <v-autocomplete dense outlined
                                                                            v-model="predefineDropDownDependent[qIndex][optDropIndex].selectedValue"
                                                                            :items="predefineDropDownDependent[qIndex][optDropIndex].items" item-value="id" item-text="name"
                                                                            :label="$t('Select')"
                                                                            @change="handlePredefineDependentDropdownChange(qIndex,optDropIndex,predefineDropDownDependent[qIndex][optDropIndex],predefineDropDownDependent)" />
                                                        </div>
                                                    </v-row>
                                                </div>
                                            </div>

                                            <div v-if="question.questionTypeId == multipleChoice || question.questionTypeId == checkbox || question.questionTypeId == dropdown || question.questionTypeId == trickyQuestion">
                                                <!--dropdown-->
                                                <v-autocomplete :rules="question.required ? nameRules : []" dense outlined v-if="question.questionTypeId == dropdown || question.questionTypeId == trickyQuestion" v-model="question.selectedValue" :items="question.options" item-value="id" item-text="name" :label="$t('Select')" />

                                                <!--radio-->
                                                <v-radio-group v-if="question.questionTypeId == multipleChoice" v-model="question.selectedValue">
                                                    <v-radio hide-details v-for="(option, optIndex) in question.options" :key="optIndex" :disabled="question.voted" :label="option.name" :value="option.id" />
                                                </v-radio-group>

                                                <!--checkbox-->
                                                <template v-if="question.questionTypeId == checkbox">
                                                    <v-checkbox v-for="(option, chkIndex) in question.options" :key="chkIndex" v-model="question.selectedValue" :disabled="question.voted" dense :label="option.name" :value="option.id" />
                                                </template>
                                            </div>

                                        </div>

                                    </v-card-text>

                                    <v-card-actions class="grey lighten-1">
                                        <v-btn v-if="surveyStepper != steps" color="primary" @click="nextStep(page.number)">
                                            {{ $t('Next') }}
                                        </v-btn>
                                        <v-btn v-if="surveyStepper > 1" color="primary" @click="previousStep(page.number)">
                                            {{ $t('Previous') }}
                                        </v-btn>
                                        <v-btn v-if="surveyStepper == steps" color="secondary" @click="complete">
                                            {{ $t('Complete') }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-form>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-container>
        </v-card>
        <v-card tile v-if="submitted">
            <v-card-text>
                <v-alert border="top" color="secondary" dark>
                    {{ $t('SurveySubmitted') }}
                </v-alert>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
    import SurveyService from '@/services/SurveyService.js'
    import { FormMethodEnum } from '@/helpers/constants/enumerations.js'
    import DatePicker from '@/components/controls/DatePicker.vue'
    import LookupAdminService from '@/services/LookupAdminServices.js'
    import SmileyRating from '@/components/controls/SmileyRating.vue'
    import StarRating from '@/components/controls/StarRating.vue'
    import LikeDislike from '@/components/controls/LikeDislike.vue'
    import NPS from '@/components/controls/NPS.vue'
    import { Editor } from '@tiptap/vue-2'
    import { EditorContent } from '@tiptap/vue-2'
    import StarterKit from '@tiptap/starter-kit'
    import Link from '@tiptap/extension-link'
    export default {
        components: {
            DatePicker, LikeDislike, SmileyRating, StarRating, NPS
        },

        data() {
            return {
                editor: null,
                valid: true,
                submitted: false,
                loading: false,
                survey: null,
                surveyStepper: 1,
                steps: null,
                textEditor: FormMethodEnum.TextEditor,
                shortAnswer: FormMethodEnum.ShortAnswer,
                checkbox: FormMethodEnum.Checkboxes,
                multipleChoice: FormMethodEnum.MultipleChoice,
                dropdown: FormMethodEnum.Dropdown,
                trickyQuestion: FormMethodEnum.TrickyQuestion,
                PredefineDropdown: FormMethodEnum.PredefineDropdown,
                rating: FormMethodEnum.Rating,
                number: FormMethodEnum.number,
                yesNo: FormMethodEnum.YesNo,
                date: FormMethodEnum.Date,
                textArea: FormMethodEnum.TextArea,
                nps: FormMethodEnum.NPS,

                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                PredefineDropdownItems: [],
                PredefineDropdownSelectedValue: [],
                predefineDropDownDependent: {},
                itemsForDropdown: []
            }
        },

        created() {
            if (this.$route.query.id) {
                this.loadSurveyForm(this.$route.query.id)
            }
        },
        mounted() {
            this.editor = new Editor({
                content: '',
                extensions: [StarterKit,
                    Link.configure({
                        openOnClick: false,
                        autolink: true,
                        defaultProtocol: 'https',
                    })
                ],
            })
        },

        beforeDestroy() {
            this.editor.destroy()
        },
        computed: {
            itemsForLookupRelatedParent() {
                return this.itemsParetRelated.map(item => ({ id: item.recordPK, name: item.nameEn }))
            }
        },
        watch: {
            'survey.pages': {
                handler(val) {
                    for (var i = 0; i < this.survey.pages.length; i++) {
                        for (var j = 0; j < this.survey.pages[i].questions.length; i++) {
                            if (this.survey.pages[i].questions[j].questionTypeId == this.PredefineDropdown) {
                                this.PredefineDropdownItemsPage(this.survey.pages[i].questions[j].lookupId)
                                    .then(items => {
                                        this.PredefineDropdownItems = items
                                    })
                                break
                            }
                        }
                    }
                },
                deep: true
            },
            'predefineDropDownDependent': {
                handler(val) {
                    console.log(val)
                },
                deep: true
            }
        },
        methods: {
            setLink() {
                const previousUrl = this.editor.getAttributes('link').href
                const url = window.prompt('URL', previousUrl)

                // cancelled
                if (url === null) {
                    return
                }

                // empty
                if (url === '') {
                    this.editor
                        .chain()
                        .focus()
                        .extendMarkRange('link')
                        .unsetLink()
                        .run()

                    return
                }

                // update link
                this.editor
                    .chain()
                    .focus()
                    .extendMarkRange('link')
                    .setLink({ href: url })
                    .run()
            },
            nextStep(n) {
                var valid = this.$refs.surveyVoteForm[n - 1].validate()
                if (valid) {
                    if (n === this.steps) {
                        this.surveyStepper = 1
                    }
                    else {
                        this.surveyStepper = n + 1
                    }
                }
            },
            previousStep(n) {
                if (n > 1) {
                    this.surveyStepper = n - 1
                }
            },

            complete() {
                var valid = this.$refs.surveyVoteForm[this.steps - 1].validate()
                if (valid) {
                    this.loading = true
                    var result = this.wrapQuestions()
                    SurveyService.vote(this.$route.query.id, result).then((res) => {
                        this.submitted = true
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },

            wrapQuestions() {
                let postQuestions = []
                for (var i = 0; i < this.survey.pages.length; i++) {
                    var currentPage = this.survey.pages[i]
                    if (currentPage) {
                        for (var j = 0; j < currentPage.questions.length; j++) {
                            var currentQuestion = currentPage.questions[j]
                            if (currentQuestion) {
                                postQuestions.push(currentQuestion)
                            }
                        }
                    }
                }
                return postQuestions
            },
            PredefineDropdownItemsPage(lookupId) {
                return new Promise((resolve, reject) => {
                    LookupAdminService.listLookupItems(lookupId)
                        .then((res) => {
                            const items = res.data.map(item => ({ id: item.recordPK, name: item.nameEn }))
                            resolve(items)
                        })
                        .catch((error) => {
                            console.error('Error fetching lookup items:', error)
                            reject(error)
                        })
                })
            },
            handlePredefineDropdownChange(qIndex, selectedValueOption) {
                console.log('Selected item:', selectedValueOption)

                LookupAdminService.listLookupItemsIfHasChild(selectedValueOption).then((res) => {
                    
                    const itemsParentRelated = res.data.map(item => ({ id: item.recordPK, name: item.nameEn }))

                    if (itemsParentRelated.length > 0) {
                        this.$set(this.PredefineDropdownSelectedValue, qIndex, selectedValueOption)

                        this.$set(this.predefineDropDownDependent, qIndex, { 0: [] })

                        this.$set(this.predefineDropDownDependent[qIndex][0], 'items', itemsParentRelated)
                    } else {
                        this.predefineDropDownDependent = {}
                    }
                }).catch((error) => {
                    console.error('Error fetching lookup items:', error)
                })
            },
            handlePredefineDependentDropdownChange(qIndex, optIndex, selectedValueOption, dict) {
                let val = selectedValueOption.selectedValue

                LookupAdminService.listLookupItemsIfHasChild(val).then((res) => {
                    
                    const itemsParentRelated = res.data.map(item => ({ id: item.recordPK, name: item.nameEn }))
                    optIndex = parseInt(optIndex) + 1
                    if (itemsParentRelated.length > 0) {

                        for (const key in this.predefineDropDownDependent[qIndex]) {
                            if (this.predefineDropDownDependent[qIndex].hasOwnProperty(key)) {
                                if (Number(key) > optIndex - 1) {
                                    this.$set(this.predefineDropDownDependent[qIndex][key], 'items', [])
                                    delete this.predefineDropDownDependent[qIndex][key]
                                }
                            }
                        }

                        if (!this.predefineDropDownDependent[qIndex].hasOwnProperty(optIndex)) {
                            this.$set(this.predefineDropDownDependent[qIndex], optIndex, [])
                        }

                        this.$set(this.predefineDropDownDependent[qIndex][optIndex], 'items', itemsParentRelated)
                    } else {
                        for (const key in this.predefineDropDownDependent[qIndex]) {
                            if (this.predefineDropDownDependent[qIndex].hasOwnProperty(key)) {
                                if (Number(key) > optIndex - 1) {
                                    this.$set(this.predefineDropDownDependent[qIndex][key], 'items', [])
                                    delete this.predefineDropDownDependent[qIndex][key]
                                }
                            }
                        }
                        //this.$set(this.predefineDropDownDependent[qIndex][optIndex], 'items', [])
                    }


                }).catch((error) => {
                    console.error('Error fetching lookup items:', error)
                })
            },
            loadSurveyForm(id) {
                this.loading = true
                SurveyService.getSurveyFormById(id).then((res) => {
                    this.survey = res.data
                    this.steps = res.data.pages.length
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
        },
    }
</script>

<style>
    .options {
        border: 0
    }
</style>